export const GENEREATE_LINK  = window.generatedLink;